let local = 'https://internal-api.chally.com', BACKEND_API_BASE_PATH = local;
const { REACT_APP_BACKEND_API_BASE_PATH } = process.env;
BACKEND_API_BASE_PATH = REACT_APP_BACKEND_API_BASE_PATH;
const BACKEND_API_AUTH_PATH = BACKEND_API_BASE_PATH;

const formatQuery = (params) => {
    let query = '';

    if (typeof params === 'object' && params !== null) {
        let pairs = [];
        const queries = [];

        if (Array.isArray(params)) {
            pairs = params;
        } else {
            pairs = Object.keys(params)
                .filter(key => params[key] !== undefined)
                .map(key => ({ [key]: params[key] }));
        }

        pairs.forEach((pair) => {
            if (typeof pair === 'object' && pair !== null && !Array.isArray(pair)) {
                Object.keys(pair).forEach((key) => {
                    queries.push(`${encodeURIComponent(key)}=${encodeURIComponent(pair[key])}`);
                });
            }
        });

        query = queries.join('&');
    }

    return query;
};

const formatUrl = (url, params = {}) => {
    const query = formatQuery(params);
    let adjustedUrl = url;

    if (query) {
        adjustedUrl = adjustedUrl + (adjustedUrl.indexOf('?') === -1 ? '?' : '&') + query;
    }

    if (adjustedUrl.startsWith('http')) {
        return adjustedUrl;
    }

    adjustedUrl = adjustedUrl.startsWith('/') ? adjustedUrl : `/${adjustedUrl}`;

    if (!adjustedUrl.startsWith(BACKEND_API_AUTH_PATH)) {
        adjustedUrl = BACKEND_API_BASE_PATH + adjustedUrl;
    }

    return adjustedUrl;
};

const formatBody = (data) => {
    if (data && typeof data === 'object') {
        if (data.constructor === FormData) {
            return data;
        }

        return JSON.stringify(data);
    }

    return data;
};

const formatHeaders = (headers = {}) => {
    const formatted = new Headers();
    Object.keys(headers).forEach((key) => {
        formatted.append(key, headers[key]);
    });
    return formatted;
};

const isSuccess = status => status >= 200 && status < 300;

const processResponse = response => new Promise((resolve, reject) => {
    const contentType = response.headers.get('content-type');
    const contentParse = contentType && contentType.indexOf('application/json') !== -1 ?
        response.json() :
        response.text();
    if (isSuccess(response.status)) {
        contentParse.then(data => resolve({
            data,
            headers: response.headers,
            status: response.status,
        }));
    } else {
        contentParse.then(data => reject(Object.assign({}, data, { status: response.status })));
    }
});

export default class HttpClient {
    constructor() {
        this.config = {
            credentials: 'same-origin',
            headers: {
                'content-type': 'application/json',
            },
        };
    }

    fetch(method, url, config = {}) {
        const {
            data,
            headers = {},
            params = {},
            ...other
        } = config;

        return new Promise((resolve, reject) => {
            const formattedUrl = formatUrl(url, params);
            const formattedConfig = Object.assign({}, this.config, {
                body: formatBody(data),
                headers: formatHeaders(Object.assign({}, this.config.headers, headers)),
                method,
                ...other,
            });
            fetch(formattedUrl, formattedConfig)
                .then(processResponse)
                .then(payload => resolve(payload))
                .catch(error => reject(error));
        });
    }
}
